<script setup lang="ts">
import type { StatusClass } from "@/model/baseTypes";

defineProps<{ statusClass: StatusClass; radarType?: boolean }>();
</script>

<template>
  <div class="status-dot" :class="{ [statusClass]: true }">
    <div class="center-dot" :class="{ 'small-center-dot': radarType, [statusClass]: true }" />
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";

@mixin set-colors($color, $opacity) {
  background: $color;
  border: 0.15em solid rgba($color, $opacity);
  background-clip: padding-box;
}

// TODO: refactor to not use the mixin
@mixin status-colors($opacity: 1) {
  &.in-progress {
    @include set-colors(colors.$palette-royal-blue-50, $opacity);
  }

  &.todo {
    @include set-colors(colors.$palette-brand-50, $opacity);
  }

  &.done {
    @include set-colors(colors.$palette-grass-green-50, $opacity);
  }

  &.undefined {
    @include set-colors(colors.$palette-brand-20, $opacity);
  }
}

.status-dot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.center-dot {
  border-radius: 50%;
  width: 100%;
  height: 100%;

  @include status-colors($opacity: 0.2);
}

.small-center-dot {
  width: 62.5%;
  height: 62.5%;
  border: none;
}
</style>
